RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsGlanceView = widgets.PostDetailsColumnView.extend({
        columnWidth: 3
    });


    const FbPostDetailsGlanceWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_at_glance_title,
        description: RivalIQ.strings.facebook_insights_post_detail_at_glance_description,
        view: FbPostDetailsGlanceView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH')
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_AND_SHARES_ENGAGEMENT_TOTAL')
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_CONSUMPTIONS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_at_glance_consumptions_title
                    })
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE_BY_IMPRESSION')
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_AT_A_GLANCE, FbPostDetailsGlanceWidget);

    const FbReelDetailsGlanceWidget = FbPostDetailsGlanceWidget.extend({
        description: RivalIQ.strings.facebook_insights_reel_detail_at_glance_description,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ORGANIC_CONSUMPTIONS', {
                        name: 'Total Views',
                        description: RivalIQ.strings.facebook_insights_post_post_reel_views_description
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_TOTAL_REACH', {
                        name: 'Total Reach'
                    })
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_VIDEO_AVG_WATCH_LENGTH', {
                        description: RivalIQ.strings.facebook_insights_reel_avg_minutes_viewed_description
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_VIDEO_VIEW_TIME')
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL', {
                        name: 'Social Engagement Total',
                        description: RivalIQ.strings.facebook_insights_reels_details_social_engagement_total_description
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_REACTIONS', {
                        name: 'Total Reactions'
                    })
                },
                {
                    type: RivalIQ.apps.Analyze.widgets.Glance.type.METRIC,
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE_BY_IMPRESSION', {
                        name: 'Engagement Rate by View'
                    }),
                    submetric: metric.create('FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE_BY_PRESENCE_REACH', {
                        name: 'Eng. Rate by Page Fan'
                    })
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_REEL_AT_A_GLANCE, FbReelDetailsGlanceWidget);

});
